export const SUGGESTION_TYPES = {
  FK: 'fk',
  CREATE_FK: 'create_fk',
  STRING: 'string',
  NUMBER: 'number',
  DATETIME: 'datetime',
} as const;
